import { createIcon } from './factory'
import Icon from './truck.svg?react'

export const Truck = createIcon({ regular: Icon, bold: Icon, fill: Icon, duotone: Icon })
